// import { register } from '@/module/Register/locale/register.th.js';
import { example } from '@/module/Example/locale/example.th';
// base
import { date } from '@/helper/locale/base/base_date.th.js';
import { button } from '@/helper/locale/base/base_button.th.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.th.js';
import { contact } from '@/module/Static/ContactUs/locale/contact.th.js'
import { coupon } from '@/module/Coupon/locale/coupon.th.js';
import { creditCard } from '@/module/CreditCard/locale/creditCard.th.js';
import { deliverymethod } from '@/module/DeliveryMethod/locale/deliverymethod.th.js';
import { favorite } from '@/module/MyFavorite/locale/favorite.th.js';
import { home } from '@/module/Home/locale/home.th.js';
import { pdpa } from '@/module/Static/Pdpa/locale/pdpa.th.js'
import { profile } from '@/module/Profile/locale/profile.th.js';
import { shoppingcart } from '@/module/ShoppingCart/locale/shoppingcart.th.js';
import { login } from '@/module/Login/locale/login.th.js';
import { register } from '@/module/Register/locale/Register.th.js';
import { crownpoint } from '@/module/CrownPoint/locale/crownpoint.th.js';
import { tierlevel } from '@/module/TierLevel/locale/tierlevel.th.js';
import productDetail from '@/module/Product/locale/productDetail.th';
import myOrder from '@/module/MyOrder/locale/myOrder.th';
import { mycoupon } from '@/module/MyCoupon/locale/mycoupon.th.js';
import { store } from '@/module/Store/locale/store.th.js';
import { earnpoint } from '@/module/EarnPoint/locale/earnpoint.th.js';
import { info } from '@/module/Info/locale/info.th.js';
import { subscription } from './module/subscription/subscription.th';

export const th = {
    example: example,
    // base
    date,
    button,
    // module
    collect_point,
    contact: contact,
    coupon: coupon,
    creditCard: creditCard,
    deliverymethod: deliverymethod,
    favorite: favorite,
    home: home,
    pdpa: pdpa,
    profile: profile,
    shoppingcart: shoppingcart,
    login: login,
    register: register,
    crownpoint: crownpoint,
    tierlevel: tierlevel,
    productDetail,
    myOrder,
    mycoupon: mycoupon,
    store: store,
    earnpoint: earnpoint,
    info: info,
    subscription: subscription,

    confirm_redeem: {
        confirm: "ตกลง",
        cancel: "ยกเลิก",

        please_confirm_1: 'โปรดยืนยันใช้คะแนน',
        please_confirm_2: 'คราวพอยท์ เพื่อแลกรับสิทธิพิเศษนี้',
        after_confirm_1: 'หลังจากยืนยันการแลกสิทธิ์แล้ว สิทธิพิเศษจะยังคงอยู่ใน "คูปองของฉัน" หากคุณไม่ใช้งานทันที',
        after_confirm_2: '',
        after_confirm_3: "",

        headline: 'ยืนยัน',
        default: 'ยืนยันการรับสิทธิ์',
        defualt_have_time: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',

        subscription_please_confirm_1: 'Please confirm to use ',
        subscription_please_confirm_2: 'THB redeem this privilege',
        subscription_after_confirm_1: "After confirmation of redemption the privileges will be retained",
        subscription_after_confirm_2: '"My coupon"',
        subscription_after_confirm_3: "if you don't use it right away.",
    },
    redeem_button: {
        default: 'รับสิทธิพิเศษ',
        buy: 'ซื้อเลย',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'สินค้านี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        redeem_noti_btn: 'คลิกเพื่อแลกรับของรางวัล!',
        already_buy: 'You already buy this subscription package.',
        reward_noti: 'รับคูปอง'
    },
    purchase: {
        show_code: 'ดูโค้ด',
        code_expired: 'หมดอายุ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
    },
    serial: {
        close_btn: 'ปิด',
        default_privilege_message: 'ตามดีไซน์',
        show_code_at_shop: 'กรุณาแสดงโค้ดกับพนักงาน',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        copy_code: 'คัดลอกโค้ด',
        copied: 'คัดลอกโค้ดแล้ว',

        expire_in: 'หมดอายุใน :',
        code_expired: 'รหัสหมดอายุ',
        min: ' นาที',

        redeem_on: 'แลกสิทธิ์เมื่อ :'
    },
    shipping: {
        headline_Add: "Address",
        headline_select: "เลือกที่อยู่",
        headline_edit: "Edit Address",
        headline_add: "เพิ่มที่อยู่ใหม่",
        headline_choose_location: "เลือกที่อยู่",
        headline: 'ที่อยู่จัดส่ง',

        search_your_location: "ค้นหาตำแหน่งของคุณ",
        select_location: 'เลือกตำแหน่งนี้',
        add_new_address: 'เพิ่มที่อยู่ใหม่',

        // firstname: {
        //     name: 'ชื่อ',
        //     placeholder: 'ชื่อ',
        //     required: 'กรุณากรอกชื่อ',
        //     too_short: '',
        //     invalid: '',
        // },
        // lastname: {
        //     name: 'นามสกุล',
        //     placeholder: 'นามสกุล',
        //     required: 'กรุณากรอกนามสกุล',
        //     too_short: '',
        //     invalid: '',
        // },
        addressName: {
            name: 'กรุณากรอกที่อยู่ของคุณ เช่น "บ้าน" หรือ "ที่ทำงาน',
            placeholder: 'กรุณากรอกที่อยู่ของคุณ เช่น "บ้าน" หรือ "ที่ทำงาน',
            required: 'กรุณากรอกที่อยู่ของคุณ เช่น "บ้าน" หรือ "ที่ทำงาน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร/หมู่บ้าน/รายละเอียดที่อยู่เพิ่มเติม',
            placeholder: 'อาคาร/หมู่บ้าน/รายละเอียดที่อยู่เพิ่มเติม',
            // required: 'กรุณากรอก อาคาร/หมู่บ้าน/รายละเอียดที่อยู่เพิ่มเติม',
            required: '',
            too_short: '',
            invalid: '',
        },
        address: 'ที่อยู่',
        // address:  {
        //     name: 'ที่อยู่',
        //     placeholder: 'กรุณากรอกที่อยู่',
        //     required: 'กรุณากรอกที่อยู่',
        //     too_short: '',
        //     invalid: '',
        // },
        // contactnumber: {
        //     name: 'เบอร์โทรศัพท์',
        //     placeholder: 'เบอร์โทรศัพท์',
        //     required: 'กรุณากรอกเบอร์โทรศัพท์',
        //     too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
        //     invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        // },
        // nationalid: {
        //     name: 'เลขประจำตัวประชาชน',
        //     placeholder: 'เลขประจำตัวประชาชน',
        //     required: 'กรุณากรอกเลขประจำตัวประชาชน',
        //     too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
        //     invalid: '',
        // },
        // email: {
        //     name: 'อีเมล',
        //     placeholder: 'อีเมล',
        //     required: 'กรุณากรอกอีเมล',
        //     too_short: '',
        //     invalid: 'อีเมลไม่ถูกต้อง',
        // },
        // zipcode: {
        //     name: 'รหัสไปรษณีย์',
        //     placeholder: 'รหัสไปรษณีย์',
        //     required: 'กรุณากรอกรหัสไปรษณีย์',
        //     too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
        //     invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        // },
        // subdistrict: {
        //     name: 'แขวง/ตำบล',
        //     placeholder: 'กรุณาเลือกแขวง/ตำบล',
        //     required: 'กรุณาเลือกแขวง/ตำบล',
        //     too_short: '',
        //     invalid: '',
        // },
        // district: {
        //     name: 'เขต/อำเภอ',
        //     placeholder: 'กรุณาเลือกเขต/อำเภอ',
        //     required: 'กรุณาเลือกเขต/อำเภอ',
        //     too_short: '',
        //     invalid: '',
        // },
        // province: {
        //     name: 'จังหวัด',
        //     placeholder: 'กรุณาเลือกจังหวัด',
        //     required: 'กรุณาเลือกจังหวัด',
        //     too_short: '',
        //     invalid: '',
        // },

        isDefaultAddress: 'เลือกเป็นค่าเริ่มต้น',
        defaultAddress: 'ที่อยู่หลัก',
        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',
        save_btn: 'บันทึก',

        default: 'ค่าเริ่มต้น',
        delete: 'ลบ',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',

        confirm_delete_msg: 'คุณต้องการลบที่อยู่นี้',
        confirm_ok_btn: 'ตกลง',
    },
    tax: {
        headline_tax: "ใบกำกับภาษี",
        headline_edit: "แก้ไขใบกำกับภาษี",
        headline_add: "เพิ่มใบกำกับภาษี",
        btn_add_tax: 'เพิ่มใบกำกับภาษี',
        btn_add_tax_address: 'เพิ่มใบกำกับภาษี',
        tax_notfound: 'ยังไม่มีใบกำกับภาษี',
        modal_del_msg: 'คุณต้องการลบที่อยู่ใบกำกับภาษี {0} ใช่หรือไม่ ',
        confirm_del_btn: 'ยืนยัน',
        please_fill_out: 'กรุณาระบุข้อมูล',
        address_tax: 'ที่อยู่ใบกำกับภาษี',
        companyName: {
            name: 'ชื่อ/ ชื่อบริษัท',
            placeholder: 'ชื่อ/ ชื่อบริษัท',
            required: 'กรุณากรอกชื่อ/ ชื่อบริษัท',
            too_short: '',
            invalid: '',
        },
        nationalid: {
            name: 'หมายเลขใบกำกับภาษี',
            placeholder: 'หมายเลขใบกำกับภาษี',
            required: 'หมายเลขใบกำกับภาษี',
            too_short: 'หมายเลขใบกำกับภาษีต้องมี {0} หลัก',
            invalid: '',
        },
        contactnumber: {
            name: 'หมายเลขโทรศัพท์มือถือ',
            placeholder: 'หมายเลขโทรศัพท์มือถือ',
            required: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
            too_short: 'หมายเลขโทรศัพท์มือถือต้องมี {0} หลัก',
            invalid: 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง',
        },
        building: {
            name: 'รายละเอียด',
            placeholder: 'รายละเอียด',
            required: '',
            too_short: '',
            invalid: '',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'กรุณาเลือกแขวง/ตำบล',
            required: 'กรุณาเลือกแขวง/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'กรุณาเลือกเขต/อำเภอ',
            required: 'กรุณาเลือกเขต/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        taxpayer_id: 'เลขประจำตัวผู้เสียภาษี',
        mobile_no: 'เบอร์โทรศัพท์',
        default_address: 'ค่าเริ่มต้น',
        delete_address: 'ลบ',
        isDefaultTax: 'ตั้งค่าเริ่มต้น',
        save: 'ตกลง'
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",

        greeting1: 'สวัสดีตอนเช้า',
        greeting2: 'สวัสดีตอนกลางวัน',
        greeting3: 'สวัสดีตอนบ่าย',
        greeting4: 'สวัสดีตอนเย็น',
        guest: 'ผู้ใช้',
        signin: 'เข้าสู่ระบบ / ลงทะเบียน',

        bath: 'บาท',
        select: 'เลือก',

        menubar: {
            home: 'หน้าหลัก',
            reward: 'รางวัล',
            earn_point: 'สะสมคะแนน',
            my_order: 'รายการอาหาร',
            more: 'เพิ่มเติม',
            bk_app: 'BK  Thailand  Application',
            download: 'ดาวน์โหลดเลย!',
            download2: 'Download',
            catering: 'Catering',
        }
    },
    campaign: {
        baht: 'บาท',
        point: 'คราวน์พอยท์',
        get_point: 'ได้ ',
        use_point: 'ใช้ ',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        relate_reward: 'สิทธิพิเศษที่เกี่ยวข้อง',

        more_detail: 'เพิ่มเติม',
        point_unit: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',
        expire_date: 'วันหมดอายุ : {0}',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },

        confirm_coupon: {
            expire_on: 'รหัสจะหมดอายุใน :',
            use_now: 'ใช้',
            add_to: 'เพิ่มเข้าสู่ "คูปองของฉัน"'
        },

        warnning_guest_1: "สิทธิพิเศษสำหรับสมาชิกเท่านั้น",
        warnning_guest_2: "กรุณาเข้าสู่ระบบหรือสมัครสมาชิก",
        view_detail: "ดูรายละเอียด",
    },
    history: {
        title: 'ประวัติคะแนน',
        earn: 'รับคะแนน',
        redeem: 'ใช้คะแนน',
        expire: 'หมดอายุ',

        expire_on: 'หมดอายุ :',
        status: 'สถานะ :',
        view_code: 'ดูรหัส',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',

        monthPicker: {
            name: '',
            placeholder: '',
            required: 'กรุณาเลือกเดือน/ปี',
            too_short: '',
            invalid: '',
            month: {
                name: '',
                placeholder: 'เดือน',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'ปี',
                required: ' '
            },
        },

        expire_text: 'คะแนนของคุณจะไม่สามารถนำมานับรวมในการเลื่อนระดับในวันที่',
        crowns: 'คราวพอยท์',

        traces_msg: "ยินดีด้วย! คุณได้รับ {0} คราวพอยท์",
        used: 'ใช้แล้ว',
    },
    title: "BURGER KING® - เบอร์เกอร์คิง, โปรโมชั่น เบอร์เกอร์คิง, เบอร์เกอร์คิง 1112",
    error_user_delete: "บัญชีผู้ใช้ของคุณได้ถูกลบแล้ว คุณจะมีสิทธิ์สมัครใหม่ได้อีกครั้งภายใน 30 วัน",
    error_mantain: "เนื่องจากมีการปรับปรุง Application กรุณา Logout ออกจากระบบและ Login ใหม่อีกครั้งเพื่อปรับปรุงข้อมูลระบบ",
    cookie: {
        cookie_text: "เบอร์กอร์คิงใช้คุกกี้บนเว็บไซด์นี้ เพื่อใช้งานวบโซค์ต่อไปท่านได้ตกลงใช้งานคุกกี้ อานรายละเอียดเพิ่นเดิมได้จาก",
        privacy: "นโยบายความเป็นส่วนตัว",
        accept_cookie: "ยอมรับคุกกี้",
    },
    error_delivery: {
        delivery: "คุณสามารถสั่งอาหารได้เร็ว ๆ นี้!",
        instore: "คุณสามารถสั่งอาหารในร้านได้เร็ว ๆ นี้!",
    },
    consent: {
        terms: 'Terms & Conditions',
        privacy: 'Privacy policy',
        marketing: 'Marketing Consent',
        accept: 'ยอมรับ',
        mkt_desc: 'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก เบอร์เกอร์คิง และ ',
        mkt_desc2: 'บริษัทในเครือและแบรนด์ที่เกี่ยวข้อง',
        tab_to_button: 'เลื่อนไปล่างสุด',
    }


};
